module.exports = __webpack_public_path__ + "img/calendar.538ef122.svg";